import { createDivIn, createSpanIn } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
import { UIDRoomInviteFriendsController } from './UIDRoomInviteFriendsController.ts';
import { UIRoomFriendListController } from '../../../../shared/scripts/ui_html/room/UIRoomFriendListController.ts';
export class UIDRoomFriendListController extends UIRoomFriendListController {
    showFriendListUI() {
        super.showFriendListUI();
        if (this.inviteFriendsButton != undefined) return;
        this.inviteFriendsButton = new UIDRoomInviteFriendsController(this.friendListContainer);
    }
    animateInviteFriendsButton() {
        this.inviteFriendsButton.animateInviteFriendsButton();
    }
    setRoomId(roomId) {
        this.inviteFriendsButton.setRoomId(roomId);
    }
    createEmptyFriendMessage() {
        const emptyFriendParentContainer = createDivIn(this.friendListContainer, 'room_friend_container');
        const emptyFriendMessageContainer = createDivIn(emptyFriendParentContainer, 'room_friend_empty_message_container');
        createSpanIn(emptyFriendMessageContainer, 'room_friend_empty_message_text', {
            key: 'strings:roomPage.noFriendsOnline',
            options: {
                context: 'discord'
            }
        });
        this.emptyFriendMessage = emptyFriendParentContainer;
    }
}
